import React from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import { Icon } from '@/components';
import { RootStore } from '@/models';
import ActionBtn from '../ActionBtn';
import styles from './index.less';
import classNames from 'classnames';

interface Props extends Partial<Pick<RootStore, 'meeting'>> {
  RTCInstance?: RootStore['rtc'];
}
const SpeakerBtn: React.FC<Props> = inject(({ store }) => {
  return {
    RTCInstance: store.rtc,
  };
})(
  observer((props) => {
    const { RTCInstance } = props;
    const { formatMessage } = useIntl();

    return (
      <>
        {!!RTCInstance?.deviceOptions && RTCInstance?.deviceOptions.audioOut.length < 0 ? (
          <ActionBtn
            title={formatMessage({ id: 'SPEAKER' })}
            className={classNames(styles.speakerBtn, {
              [styles.disable]: RTCInstance?.breakLineReconnecting,
            })}
            onClick={() => {
              if (RTCInstance?.breakLineReconnecting) {
                return;
              }
              RTCInstance?.setAudioOutValueNext.bind(RTCInstance);
            }}
          >
            <Icon className={styles.icon} name="icon-speaker_soild" />
          </ActionBtn>
        ) : null}
      </>
    );
  })
);

export default SpeakerBtn;
